import type { ShipmentStatus } from '../../api/types';

/** One friendly wording for every shipment status. Typed Record = exhaustive at compile time. */
export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatus, string> = {
  DRAFT: 'Draft',
  POSTED: 'Posted',
  AWARDED: 'Awarded',
  ASSIGNED: 'Driver assigned',
  EN_ROUTE_PICKUP: 'Heading to pickup',
  AT_PICKUP: 'At pickup',
  LOADED: 'Loaded',
  IN_TRANSIT: 'In transit',
  AT_DROP: 'At drop',
  DELIVERED: 'Delivered',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  EXCEPTION: 'Needs attention',
};

/** Label for a shipment status code. Unknown/future codes never leak as raw text. */
export function shipmentStatusLabel(status?: string | null): string {
  if (status && Object.prototype.hasOwnProperty.call(SHIPMENT_STATUS_LABELS, status)) {
    return SHIPMENT_STATUS_LABELS[status as ShipmentStatus];
  }
  return 'Unknown status';
}
